import DatasetAttributeGroup from '../dataset_attribute_group';
import MeasureAttribute from './measure_attribute';
import {ATTRIBUTES} from "../../../../../../utils/query_utils";

export default class MeasuresGroup extends DatasetAttributeGroup {
    placeholder = 'Total revenue, Count of users, ...';
    type = ATTRIBUTES.MEASURE;
    AttributeComponent = MeasureAttribute;
}
